import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import styled, { createGlobalStyle, keyframes } from "styled-components";
import axios from "axios";
import SiteFooter from "../components/SiteFooter";

const Global = createGlobalStyle`
  @import url('https://cdn.jsdelivr.net/gh/orioncactus/pretendard/dist/web/static/pretendard.css');
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { background: #f0ebe3; font-family: 'Pretendard', sans-serif; }
`;

const spin = keyframes`from{transform:rotate(0deg)}to{transform:rotate(360deg)}`;
const fadeUp = keyframes`from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:translateY(0)}`;

const Wrap = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
`;

const Card = styled.div`
  width: 100%;
  max-width: 440px;
  background: #fff;
  border: 1.5px solid #e0d5c8;
  border-radius: 20px;
  padding: 48px 28px;
  box-shadow: 0 4px 24px rgba(100,70,40,0.10);
  text-align: center;
  animation: ${fadeUp} 0.4s ease;
`;

const Spinner = styled.div`
  width: 48px; height: 48px;
  border: 4px solid #f0e8de;
  border-top-color: #c09a6b;
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
  margin: 0 auto 20px;
`;

const Icon = styled.div`font-size: 3rem; margin-bottom: 12px;`;
const Title = styled.h2`font-size: 1.2rem; color: #3d2b1f; font-weight: 800; margin-bottom: 8px;`;
const Desc = styled.p`font-size: 0.85rem; color: #7a6654; line-height: 1.7;`;
const ErrBtn = styled.button`
  margin-top: 20px;
  padding: 12px 28px;
  background: #c09a6b;
  color: #fff;
  border: none;
  border-radius: 24px;
  font-size: 0.9rem;
  font-weight: 700;
  cursor: pointer;
  font-family: inherit;
`;

const API = process.env.REACT_APP_API_URL || "";

export default function PaymentSuccessPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<"loading" | "ok" | "error">("loading");
  const [errMsg, setErrMsg] = useState("");

  useEffect(() => {
    const paymentKey     = params.get("paymentKey") || "";
    const orderId        = params.get("orderId") || "";
    const amount         = Number(params.get("amount") || 0);
    // orderId 형식: saju_{consultationId}_{timestamp}
    const consultationId = Number(orderId.split("_")[1] || 0);

    if (!paymentKey || !orderId || !amount || !consultationId) {
      setStatus("error");
      setErrMsg("결제 정보가 올바르지 않습니다.");
      return;
    }

    axios.post(`${API}/api/v1/client/payment-verify`, {
      payment_key: paymentKey,
      order_id: orderId,
      amount,
      consultation_id: consultationId,
    })
      .then(res => {
        setStatus("ok");
        setTimeout(() => {
          navigate(`/report/${consultationId}`, { replace: true });
        }, 1800);
      })
      .catch(err => {
        setStatus("error");
        setErrMsg(err.response?.data?.detail || "결제 처리 중 오류가 발생했습니다.");
      });
  }, [params, navigate]);

  return (
    <>
      <Global />
      <Wrap>
        <Card>
          {status === "loading" && (
            <>
              <Spinner />
              <Title>결제 확인 중...</Title>
              <Desc>잠시만 기다려주세요.<br />결제 내역을 검증하고 있습니다.</Desc>
            </>
          )}
          {status === "ok" && (
            <>
              <Icon>✅</Icon>
              <Title>결제 완료!</Title>
              <Desc>
                리포트를 준비했습니다.<br />
                잠시 후 결과 페이지로 이동합니다.
              </Desc>
            </>
          )}
          {status === "error" && (
            <>
              <Icon>❌</Icon>
              <Title>결제 처리 실패</Title>
              <Desc>{errMsg}</Desc>
              <ErrBtn onClick={() => navigate("/client")}>다시 시도하기</ErrBtn>
            </>
          )}
        </Card>
        <SiteFooter />
      </Wrap>
    </>
  );
}
